import { Colors } from "../../config";

const styles = {
    container: {
        // height:"100vh",
        display: "flex",
        flexFlow: "column wrap",
        backgroundColor: Colors.White,
        justifyContent: 'center',
    }
}

export default styles